import React, { useState, useEffect } from 'react';
import booksData from '../data/books.json';
import BookCard from '../components/BookCard';

const Origins = () => {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    setBooks(booksData);
  }, []);

  return (
    <div className="min-h-screen bg-dark-slate py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif text-porcelain-white mb-4">
            The Library
          </h1>
          <p className="text-lg text-porcelain-white/70 max-w-2xl mx-auto">
            Explore timeless classics that bridge cultures and centuries
          </p>
        </div>

        {/* Book Grid - Perfect 3x3 Museum Display: 1 col mobile, 2 col tablet, 3 col desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto items-stretch">
          {books.map((book) => (
            <div key={book.id} className="flex">
              <BookCard book={book} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Origins;
